function GetEnvVariable(key: string): string {
  const envValue = import.meta.env[`VITE_APP_${key}`];
  const windowValue = (window as any)[key];
  if (!envValue && !windowValue) return "";
  return windowValue || envValue;
}

export const API_BASE_URL = GetEnvVariable("API_BASE_URL");
